<template>
    <div ref="targetElement" class="app">  <!-- viewBox="0 0 150 202" --> <!--width="150"height="202" -->
      <svg
        width="150"
        height="150"
        viewBox="0 0 150 202"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="svg">
          <g id="logo">
            <g id="SupS">
              <g id="Vector">
                <path
                  d="M105 61C105 58.2386 107.239 56 110 56H143C145.761 56 148 58.2386 148 61V94C148 96.7614 145.761 99 143 99H110C107.239 99 105 96.7614 105 94V61Z"
                />
                <path
                  d="M52 8C52 5.23858 54.2386 3 57 3H90C92.7614 3 95 5.23858 95 8V41C95 43.7614 92.7614 46 90 46H57C54.2386 46 52 43.7614 52 41V8Z"
                />
                <path
                  d="M0 61C0 58.2386 2.23858 56 5 56H38C40.7614 56 43 58.2386 43 61V94C43 96.7614 40.7614 99 38 99H5C2.23858 99 0 96.7614 0 94V61Z"
                />
                <path
                  d="M52 114C52 111.239 54.2386 109 57 109H90C92.7614 109 95 111.239 95 114V147C95 149.761 92.7614 152 90 152H57C54.2386 152 52 149.761 52 147V114Z"
                />
                <path
                  d="M34.5 55.5C44.5962 50.6333 48.7816 46.9267 52 37.5L61 46.5C51.9774 49.0829 47.9305 52.8008 42.5 63.5L34.5 55.5Z"
                />
                <path
                  d="M52 117.538C46.9548 107.53 42.6422 101.549 33.1598 98.4983L41.9986 89.3399C44.7413 98.3152 50.706 104.298 61.5 109.538L52 117.538Z"
                />
                <path
                  d="M105 64.538C99.9548 54.5298 95.6422 48.5488 86.1598 45.4983L94.9986 36.3399C97.7413 45.3152 103.706 51.2983 114.5 56.538L105 64.538Z"
                />
              </g>
            </g>
            <g id="BotS">
              <g id="Vector_2">
                <path
                  d="M54 61C54 58.2386 56.2386 56 59 56H92C94.7614 56 97 58.2386 97 61V94C97 96.7614 94.7614 99 92 99H59C56.2386 99 54 96.7614 54 94V61Z"
                />
                <path
                  d="M105 114C105 111.239 107.239 109 110 109H143C145.761 109 148 111.239 148 114V147C148 149.761 145.761 152 143 152H110C107.239 152 105 149.761 105 147V114Z"
                />
                <path
                  d="M52 164C52 161.239 54.2386 159 57 159H90C92.7614 159 95 161.239 95 164V197C95 199.761 92.7614 202 90 202H57C54.2386 202 52 199.761 52 197V164Z"
                />
                <path
                  d="M0 114C0 111.239 2.23858 109 5 109H38C40.7614 109 43 111.239 43 114V147C43 149.761 40.7614 152 38 152H5C2.23858 152 0 149.761 0 147V114Z"
                />
                <path
                  d="M87 160C97.0962 155.133 101.282 151.427 104.5 142L113.5 151C104.477 153.583 100.431 157.301 95 168L87 160Z"
                />
                <path
                  d="M106 118.538C100.955 108.53 96.6422 102.549 87.1598 99.4983L95.9986 90.3399C98.7413 99.3152 104.706 105.298 115.5 110.538L106 118.538Z"
                />
                <path
                  d="M53 170.538C47.9548 160.53 43.6422 154.549 34.1598 151.498L42.9986 142.34C45.7413 151.315 51.706 157.298 62.5 162.538L53 170.538Z"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
</template>

<style>

  @media (min-width: 1024px) { 
    .app{
      height: 5em;
      /* padding: 1px;  */
    }
   }

  .app {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40em;
    /* padding: 20em;  */
  }

  #SupS {
    animation: fadeIn infinite 2s ease-in, changeColor forwards 3s ease-out;
  }

  #BotS {
    animation: fadeIn infinite 2s ease-out, changeColor forwards 3s linear;
  }

  @keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
  }

  @keyframes changeColor {
    from {
        fill: rgb(108,203,156);
    }
    to {
        fill: rgb(4,108,100);
    }
  }
</style>

<script>
  import { mapState } from "vuex";

  export default {
    name: 'loadingLogo',
    computed: {
          ...mapState(['scrollHandler', 'statusLoadingRoute'])
    },
    mounted() {
      if (window.innerWidth < 1024) {
        this.$nextTick(() => {
            if (this.scrollHandler) {
                this.$refs.targetElement.scrollIntoView({ behavior: 'smooth', block: "start" });
            }
        this.addScrollHandler(false)
        });            
      }
    },
  }
</script>